<script setup lang="ts">
import { computed } from 'vue';
import Fluid from 'primevue/fluid';
import InputTextAera from 'primevue/textarea';

const props = defineProps<{
  type: string;
  cruise: any;
  permission?: boolean;
  isShowError?: boolean;
  labelNote: string;
}>();

const emits = defineEmits<{
  'update:cruise': [value: any];
}>();

const cruiseData = computed({
  get() {
    return props.cruise;
  },
  set(value) {
    emits('update:cruise', value);
  }
});

const showValidateError = computed(() => {
  return props.type === 'transfers' && props.isShowError && !cruiseData.value.transfers;
});
</script>
<template>
  <div class="cruise-note">
    <Fluid>
      <div class="field">
        <div class="flex-col">
          <div class="m-2 text-3xl font-bold uppercase mt-4" v-if="type === 'transfers'">{{ $t('create_quote.transfers') }}</div>
          <label v-else for="adt">{{ labelNote }}</label>
          <InputTextAera v-model="cruiseData[type]" class="not-resize" :autoResize="true" rows="5" cols="30" :class="showValidateError ? 'p-invalid' : ''" />
          <span class="text-red-500" v-if="showValidateError"> {{ $t('validate.required') }} </span>
        </div>
      </div>
    </Fluid>
  </div>
</template>
